/*
 * @Author: young young@sinokru.com
 * @Date: 2023-11-02 10:42:28
 * @LastEditors: young young@sinokru.com
 * @LastEditTime: 2023-11-02 10:48:11
 * @FilePath: /fm_wx_store/src/config/env.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */
import config from "../../config/index";
let baseFMUrl = "https://api.findmacau.com/uat/fm"; // API
let baseUrl = "https://api.findmacau.com/uat/fm";
let routerMode = "history";
let weChatRedirectUrl = "https://uatweb.findmacau.com"; // 网址
// let weChatRedirectUrl = 'http://bd.findmacau.com'// 网址
let appId = "wxdaf1a21ce53a6a8a";
// "wxe9ec970aa206a121"+//正式环境的appid-发现澳门
// "wxdaf1a21ce53a6a8a"+//测试环境appid-Mosignal
// 高德地图 key
let MapKey = "7929b5f8ae14bed1410a31396536b0de";
// 地图限定城市
let MapCityName = "澳门";
let staticurl = "";
let youmengId = "";
let youmengUrl = "";
let mainrouterpath = "";
let XAUTHTOKEN = "x-auth-token";

let bocOpenKey = "1364211734176333824";
if (process.env.NODE_ENV === "development") {
  mainrouterpath = "/";
  youmengId = "1271879226";
  youmengUrl = "https://s95.cnzz.com/z_stat.php";
  baseFMUrl = "https://api.findmacau.com/uat/fm";
  //开发下面配置正式环境商品url
  //  baseFMUrl = "https://api.findmacau.com/fm";
  bocOpenKey = "1364211734176333824",


    // baseFMUrl = 'http://localhost:8888/fm'
    weChatRedirectUrl = "http://" + config.dev.host + ":" + config.dev.port; // http://localhost:8000/login
  // weChatRedirectUrl = 'http://bd.findmacau.com'
  appId = "wxdaf1a21ce53a6a8a"; //测试mosignal
  // appId= 'wxe9ec970aa206a121';//正式发现澳门公众号
  baseUrl = "https://api.findmacau.com/uat/fm";
  // baseUrl = "https://api.findmacau.com/fm";
  // baseUrl = 'http://192.168.25.57/fm';
  MapKey = "7929b5f8ae14bed1410a31396536b0de";
  staticurl = weChatRedirectUrl + "/static";
  MapCityName = "澳门";
  XAUTHTOKEN = "x-auth-token";
} else if (process.env.NODE_ENV === "production") {
  mainrouterpath = "/";
  youmengId = "1271876389";
  youmengUrl = "https://s22.cnzz.com/z_stat.php";
  baseFMUrl = "https://api.findmacau.com/fm";
  weChatRedirectUrl = "https://web.findmacau.com";
  appId = "wxe9ec970aa206a121";
  baseUrl = "https://api.findmacau.com/fm";
  MapKey = "7929b5f8ae14bed1410a31396536b0de";
  staticurl = weChatRedirectUrl;
  bocOpenKey = "1400407931802877952",
    MapCityName = "澳门";
  XAUTHTOKEN = "x-auth-token";
} else if (process.env.NODE_ENV === "uat") {
  mainrouterpath = "/uat/";
  youmengId = "1271879226";
  bocOpenKey = "1364211734176333824",
    youmengUrl = "https://s95.cnzz.com/z_stat.php";
  baseFMUrl = "https://api.findmacau.com/uat/fm";
  // baseFMUrl ='http://192.168.25.57/fm';
  weChatRedirectUrl = "https://uatweb.findmacau.com";
  // weChatRedirectUrl = "http://bd.findmacau.com";
  appId = "wxdaf1a21ce53a6a8a"; // mosignal
  // appId = "wxe9ec970aa206a121"; // 正式环境
  baseUrl = "https://api.findmacau.com/uat/fm";
  // baseUrl = 'http://192.168.25.57/fm';
  MapKey = "7929b5f8ae14bed1410a31396536b0de";
  staticurl = weChatRedirectUrl;
  MapCityName = "澳门";
  XAUTHTOKEN = "x-auth-token";
}
export {
  baseFMUrl,
  baseUrl,
  weChatRedirectUrl,
  appId,
  routerMode,
  MapKey,
  MapCityName,
  staticurl,
  youmengId,
  youmengUrl,
  mainrouterpath,
  XAUTHTOKEN,
  bocOpenKey
};



// WEBPACK FOOTER //
// ./src/config/env.js